import { request } from '@/data/request';

export const markNotificationAsRead = (id: number) => {
  return request<any>({
    method: 'put',
    url: `/attendance-notification/mark-as-read/${id}`,
  });
};
